export function enterToFocusMove(event) {
  if (event.key === "Enter") {
    event.preventDefault();
    const focusableElements = document.querySelectorAll("input, textarea");

    const activeElement = document.activeElement;

    const currentIndex = Array.prototype.indexOf.call(
      focusableElements,
      activeElement
    );

    let nextElement;

    if (event.shiftKey) {
      nextElement = focusableElements[currentIndex - 1] || focusableElements[0];
    } else {
      nextElement = focusableElements[currentIndex + 1] || focusableElements[0];
    }

    nextElement.focus();
  }
}
